var lease_types = {
  lease_types: {
    fixed: "fixed",
    month_to_month: "month_to_month",
    yearly: "yearly",
    year_month_to_month: "year_month_to_month",
    other: "other"
  }
}

module.exports = lease_types
